module.exports = __webpack_public_path__ + "static/media/icn-53-equipment.a54c4585.svg";